import { BROWSER_TYPE_MAP } from 'utils/constants'

//
// Utility to check if an element is in view of the window
//

export const scrollToTop = (delay, smooth = true) => {
  setTimeout(() => {
    if (smooth) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    } else {
      window.scrollTo(0, 0)
    }
  }, delay)
}

export const isInView = domEl => {
  const docViewTop = window.scrollTop()
  const docViewBottom = docViewTop + window.innerHeight

  const elemTop = domEl.offsetTop
  const elemBottom = elemTop + domEl.offsetHeight

  return elemBottom <= docViewBottom && elemTop >= docViewTop
}

const isInUserAgent = string => {
  const { userAgent } = navigator
  if (userAgent.indexOf(string) !== -1) return true
  return false
}
const returnBrowserType = () => {
  const { userAgent } = navigator
  // Opera 8.0+
  if (
    (!!window.opr && !!window.opr.addons) ||
    !!window.opera ||
    navigator.userAgent.indexOf(' OPR/') >= 0 ||
    userAgent.indexOf('OPT') !== -1
  ) {
    return BROWSER_TYPE_MAP.opera
  }

  // Internet Explorer 6-11
  const isIE = /* @cc_on!@ */ false || !!document.documentMode
  if (isIE) {
    return 'ie'
  }

  // Edge 20+
  if (
    (!isIE && !!window.StyleMedia) ||
    isInUserAgent('EdgiOS') ||
    isInUserAgent('Edge')
  ) {
    return BROWSER_TYPE_MAP.edge
  }

  // Firefox 1.0+
  if (typeof InstallTrigger !== 'undefined' || isInUserAgent('FxiOS')) {
    return BROWSER_TYPE_MAP.firefox
  }

  // Safari 3.0+ "[object HTMLElementConstructor]"
  if (
    /constructor/i.test(window.HTMLElement) ||
    (function safariRemoteCheck(p) {
      return p.toString() === '[object SafariRemoteNotification]'
    })(
      !window.safari ||
        (typeof window.safari !== 'undefined' && window.safari.pushNotification)
    ) ||
    (isInUserAgent('Version') &&
      (isInUserAgent('iPhone') || isInUserAgent('iPad')))
  ) {
    return BROWSER_TYPE_MAP.safari
  }

  // Chrome 1 - 71
  if (
    (!!window.chrome &&
      (!!window.chrome.webstore || !!window.chrome.runtime)) ||
    isInUserAgent('CriOS') ||
    isInUserAgent('GSA') ||
    isInUserAgent('Chrome')
  ) {
    return BROWSER_TYPE_MAP.chrome
  }

  return BROWSER_TYPE_MAP.safari
}

export default returnBrowserType
